import {
  PaginatedSelectionContextProvider,
  usePaginatedSelection,
  type UsePaginatedSelectionProps,
} from '@autone/ui-next/components';
import { type PropsWithChildren, useEffect } from 'react';

import { useGetSkuLocationsTableQueryArgs } from './hooks/useGetSkuLocationsTableQueryArgs';
import { usePaginatedAssortmentSkuLocationsQuery } from './SkuLocationsTable.utilities';

interface SkuLocationsPaginatedSelectionContextProviderProps
  extends PropsWithChildren,
    Omit<UsePaginatedSelectionProps, 'totalRowCount'> {}

export const SkuLocationsPaginatedSelectionContextProvider = ({
  children,
  ...props
}: SkuLocationsPaginatedSelectionContextProviderProps) => {
  const queryArgsWithNoSearchTerm = useGetSkuLocationsTableQueryArgs({
    searchTerm: '',
  });
  const { totalRowCount } = usePaginatedAssortmentSkuLocationsQuery(
    queryArgsWithNoSearchTerm,
    {
      initialPageIndex: 0,
      initialPageSize: 1,
    },
    (page) => ({ totalRowCount: page?.page_info.total_count ?? 0 }),
  );

  const value = usePaginatedSelection({
    ...props,
    totalRowCount: totalRowCount,
  });
  const [, { clearSelection }] = value;

  // Clear selection when filters change
  useEffect(() => {
    clearSelection();
  }, [queryArgsWithNoSearchTerm, clearSelection]);

  return (
    <PaginatedSelectionContextProvider value={value}>
      {children}
    </PaginatedSelectionContextProvider>
  );
};
